import { companyRoleRestrictionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE = createNamedActions('companyRoleRestrictions', {
  GET_RESTRICTIONS: 'GET_COMPANY_ROLE_RESTRICTIONS',
  UPDATE_RESTRICTIONS: 'UPDATE_COMPANY_ROLE_RESTRICTIONS',
  RESET_RESTRICTIONS: 'RESET_COMPANY_ROLE_RESTRICTIONS',
});

export const resetCompanyRoleRestrictionsAction = () => ({
  type: COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.RESET_RESTRICTIONS,
});

export const getCompanyRoleRestrictionsAction = catchAsyncActionError(
  ({ companyId, skipForbiddenError }) =>
    async dispatch => {
      const { data } = await companyRoleRestrictionsApi.getRestrictions({
        companyId,
        skipForbiddenError,
      });

      return dispatch({
        type: COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.GET_RESTRICTIONS,
        payload: data,
      });
    },
);

export const updateCompanyRoleRestrictionsAction = catchAsyncActionError(
  ({ companyId, restrictedRoleIds }) =>
    async dispatch => {
      const { data } = await companyRoleRestrictionsApi.updateRestrictions({
        companyId,
        restrictedRoleIds,
      });

      return dispatch({
        type: COMPANY_ROLE_RESTRICTIONS_ACTION_TYPE.UPDATE_RESTRICTIONS,
        payload: data,
      });
    },
);
